module.exports = __webpack_public_path__ + "img/stonk.742a1dcc.png";